import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FinancialDashboard from './FinancialDashboard';
import { SEE_ALL_MONEY_MOVES_PATH } from '../your-quick-richuels/constants';
import { SuccessToast } from '../../shared/SuccessToast';
import ForecastHero from './ForecastHero';
import ForecastProgressFooter from './ForecastProgressFooter';
import useForecastPage from './useForecastPage';
import styles from './ForecastPage.module.css';

const ForecastPage = () => {
  const {
    isLoading,
    onboardingProgress,
    onboardingAiCheckupAndActionPlan,
    onboardingConfetti,
    showWalkMeThrough,
    successMsg,
    toastExiting,
    forecastFirstName,
    forecastHeroSubtitle,
    onAllDataLoaded,
    handleDisplayMetricsReady,
    handleWalkMeThroughDone,
    handleWalkMeThroughButtonClick,
  } = useForecastPage();

  const location = useLocation();
  const isUpdatedForecastLoading = Boolean(location.state?.scenarioApplied) && isLoading;
  const loadingMessage = location.state?.scenarioApplied
    ? 'Loading your updated forecast…'
    : 'Loading Forecast...';

  const navigate = useNavigate();
  const openQuickRichuels = useCallback(() => {
    navigate(SEE_ALL_MONEY_MOVES_PATH);
  }, [navigate]);

  return (
    <div
      className={`${styles.forecastPage}${isUpdatedForecastLoading ? ` ${styles.scenarioHandoff}` : ''}`}
      aria-busy={isLoading}
    >
      <SuccessToast message={successMsg} isExiting={toastExiting} />
      <FinancialDashboard
        onboardingProgress={onboardingProgress}
        onboardingAiCheckupAndActionPlan={onboardingAiCheckupAndActionPlan}
        onboardingConfetti={onboardingConfetti}
        onAllDataLoaded={onAllDataLoaded}
        onDisplayMetricsReady={handleDisplayMetricsReady}
        isModal={false}
        showHeader={false}
        headerContent={isUpdatedForecastLoading ? null : (
          <ForecastHero
            firstName={forecastFirstName}
            subtitle={forecastHeroSubtitle}
            onContinuePlan={openQuickRichuels}
          />
        )}
        footerContent={(
          <ForecastProgressFooter onStartMove={openQuickRichuels} />
        )}
        showWalkMeThrough={showWalkMeThrough}
        loadingMessage={loadingMessage}
        onWalkMeThroughDone={handleWalkMeThroughDone}
        onWalkMeThroughButtonClick={handleWalkMeThroughButtonClick}
      />
    </div>
  );
};

export default ForecastPage;
